import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

/**
 * Skip Links Component - WCAG 2.4.1
 * Allows keyboard users to skip repetitive content
 */
const SkipLinks = () => {
  const { t } = useLanguage();
  
  const skipToMain = (e) => {
    e.preventDefault();
    const main = document.getElementById('main-content');
    if (main) {
      main.focus();
      main.scrollIntoView();
    }
  };

  const skipToNav = (e) => {
    e.preventDefault();
    const nav = document.getElementById('main-navigation');
    if (nav) {
      nav.focus();
    }
  };

  const skipToCalculator = (e) => {
    e.preventDefault();
    const calc = document.getElementById('calculator-input');
    if (calc) {
      calc.focus();
    }
  };

  return (
    <div className="skip-links">
      <a 
        href="#main-content" 
        onClick={skipToMain}
        className="skip-link"
        data-testid="skip-to-main"
      >
        {t('skipToMain') || 'Skip to main content'}
      </a>
      <a 
        href="#main-navigation" 
        onClick={skipToNav}
        className="skip-link"
        data-testid="skip-to-nav"
      >
        {t('skipToNav') || 'Skip to navigation'}
      </a>
      <a 
        href="#calculator-input" 
        onClick={skipToCalculator}
        className="skip-link"
        data-testid="skip-to-calc"
      >
        {t('skipToCalculator') || 'Skip to calculator'}
      </a>
    </div>
  );
};

export default SkipLinks;
